import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withKeys as _withKeys, withModifiers as _withModifiers, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "ui-topbar-left" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  class: "ui-search",
  ref: "searchBoxRef"
}
const _hoisted_5 = ["placeholder", "aria-label"]
const _hoisted_6 = {
  key: 0,
  class: "search-dropdown",
  role: "listbox"
}
const _hoisted_7 = ["aria-selected", "onMousedown"]
const _hoisted_8 = {
  key: 1,
  class: "search-dropdown"
}
const _hoisted_9 = { class: "search-no-result" }
const _hoisted_10 = { class: "ui-topbar-right" }
const _hoisted_11 = { class: "dropdown" }
const _hoisted_12 = ["aria-label"]
const _hoisted_13 = {
  key: 0,
  class: "ui-topbar-count"
}
const _hoisted_14 = { class: "dropdown-menu dropdown-menu-end ui-topbar-menu ui-alerts-menu" }
const _hoisted_15 = { class: "ui-topbar-menu-head" }
const _hoisted_16 = { class: "ui-topbar-menu-muted" }
const _hoisted_17 = {
  key: 0,
  class: "ui-topbar-menu-empty"
}
const _hoisted_18 = {
  key: 1,
  class: "ui-alerts-list"
}
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "ui-alert-title" }
const _hoisted_21 = { class: "ui-alert-body" }
const _hoisted_22 = { class: "ui-alert-date" }
const _hoisted_23 = { class: "dropdown" }
const _hoisted_24 = {
  class: "ui-topbar-profile",
  type: "button",
  "data-bs-toggle": "dropdown",
  "data-bs-display": "static",
  "aria-expanded": "false"
}
const _hoisted_25 = { class: "ui-topbar-avatar" }
const _hoisted_26 = ["src"]
const _hoisted_27 = ["src"]
const _hoisted_28 = { class: "ui-topbar-profile-text" }
const _hoisted_29 = { class: "ui-topbar-name" }
const _hoisted_30 = { class: "ui-topbar-role" }
const _hoisted_31 = { class: "dropdown-menu dropdown-menu-end ui-topbar-menu" }
const _hoisted_32 = { class: "ui-topbar-menu-head ui-topbar-menu-user" }
const _hoisted_33 = { class: "text-truncate" }
const _hoisted_34 = { class: "ui-topbar-menu-online" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_LanguageSwitcher = _resolveComponent("LanguageSwitcher")!
  const _component_LightDarkSwtichBtn = _resolveComponent("LightDarkSwtichBtn")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(['ui-topbar', { sticky: _ctx.isSticky }]),
    id: "header"
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("button", {
        class: "ui-icon-btn ui-topbar-burger",
        id: "header-burger-menu",
        type: "button",
        "aria-label": _ctx.$t('header.openMenu'),
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.stateStoreInstance.onChange && _ctx.stateStoreInstance.onChange(...args)))
      }, _cache[9] || (_cache[9] = [
        _createElementVNode("i", {
          class: "ph ph-list",
          "aria-hidden": "true"
        }, null, -1)
      ]), 8, _hoisted_2),
      _createVNode(_component_router_link, {
        to: "/",
        class: "ui-topbar-brand",
        "aria-label": _ctx.$t('header.home')
      }, {
        default: _withCtx(() => [
          _createElementVNode("img", {
            src: _ctx.logoSrc,
            alt: ""
          }, null, 8, _hoisted_3)
        ]),
        _: 1
      }, 8, ["aria-label"]),
      _createElementVNode("div", _hoisted_4, [
        _cache[11] || (_cache[11] = _createElementVNode("i", {
          class: "ph ph-magnifying-glass ui-search-icon",
          "aria-hidden": "true"
        }, null, -1)),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          class: "ui-search-input",
          placeholder: _ctx.$t('header.searchPlaceholder'),
          "aria-label": _ctx.$t('header.searchLabel'),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchQuery) = $event)),
          onFocus: _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchOpen = true)),
          onKeydown: [
            _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeSearch && _ctx.closeSearch(...args)), ["escape"])),
            _cache[4] || (_cache[4] = _withKeys(
//@ts-ignore
(...args) => (_ctx.goToFirst && _ctx.goToFirst(...args)), ["enter"])),
            _cache[5] || (_cache[5] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.highlightNext && _ctx.highlightNext(...args)), ["prevent"]), ["down"])),
            _cache[6] || (_cache[6] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.highlightPrev && _ctx.highlightPrev(...args)), ["prevent"]), ["up"]))
          ],
          autocomplete: "off"
        }, null, 40, _hoisted_5), [
          [_vModelText, _ctx.searchQuery]
        ]),
        (_ctx.searchOpen && _ctx.searchQuery.trim() && _ctx.filteredPages.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPages, (page, i) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: page.path,
                  class: _normalizeClass(["search-result-item", { 'search-result-item--active': i === _ctx.highlightIndex }]),
                  role: "option",
                  "aria-selected": i === _ctx.highlightIndex,
                  onMousedown: _withModifiers(($event: any) => (_ctx.navigateTo(page.path)), ["prevent"])
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass([page.icon, "search-result-icon"])
                  }, null, 2),
                  _createElementVNode("span", null, _toDisplayString(_ctx.$t(page.name)), 1),
                  _cache[10] || (_cache[10] = _createElementVNode("i", {
                    class: "ph ph-arrow-right search-result-go",
                    "aria-hidden": "true"
                  }, null, -1))
                ], 42, _hoisted_7))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_ctx.searchOpen && _ctx.searchQuery.trim() && !_ctx.filteredPages.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("header.noResult")), 1)
            ]))
          : _createCommentVNode("", true)
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(_component_LanguageSwitcher),
      _createVNode(_component_LightDarkSwtichBtn),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("button", {
          class: "ui-icon-btn ui-topbar-bell",
          type: "button",
          "data-bs-toggle": "dropdown",
          "data-bs-display": "static",
          "aria-expanded": "false",
          "aria-label": _ctx.$t('header.notifications')
        }, [
          _cache[12] || (_cache[12] = _createElementVNode("i", {
            class: "ph ph-bell",
            "aria-hidden": "true"
          }, null, -1)),
          (_ctx.unreadCount)
            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.unreadCount > 99 ? "99+" : _ctx.unreadCount), 1))
            : _createCommentVNode("", true)
        ], 8, _hoisted_12),
        _createElementVNode("div", _hoisted_14, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", null, _toDisplayString(_ctx.$t("header.notifications")), 1),
            _createElementVNode("span", _hoisted_16, "(" + _toDisplayString(_ctx.unreadCount) + ")", 1),
            (_ctx.unreadCount)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  type: "button",
                  class: "ui-alerts-readall",
                  onClick: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.markAllRead && _ctx.markAllRead(...args)), ["stop"]))
                }, _toDisplayString(_ctx.$t("header.markAllRead")), 1))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.alerts.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(_ctx.$t("header.noNotifications")), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (alert) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: alert.id,
                    type: "button",
                    class: _normalizeClass(['ui-alert-item', { 'ui-alert-item--unread': !alert.read_at }]),
                    onClick: ($event: any) => (_ctx.markRead(alert))
                  }, [
                    _createElementVNode("span", _hoisted_20, _toDisplayString(alert.title), 1),
                    _createElementVNode("span", _hoisted_21, _toDisplayString(alert.body), 1),
                    _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.formatAlertDate(alert.created_at)), 1)
                  ], 10, _hoisted_19))
                }), 128))
              ])),
          (_ctx.hasMoreAlerts)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 2,
                to: "/notifications",
                class: "ui-alerts-all"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t("header.viewAllNotifications")), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_23, [
        _createElementVNode("button", _hoisted_24, [
          _createElementVNode("span", _hoisted_25, [
            (_ctx.user?.pic)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: _ctx.user.pic,
                  width: "36",
                  height: "36",
                  alt: "admin"
                }, null, 8, _hoisted_26))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: require('@/assets/images/NoImage.png'),
                  width: "36",
                  height: "36",
                  alt: "admin"
                }, null, 8, _hoisted_27)),
            _cache[13] || (_cache[13] = _createElementVNode("span", {
              class: "ui-topbar-online",
              "aria-hidden": "true"
            }, null, -1))
          ]),
          _createElementVNode("span", _hoisted_28, [
            _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.user?.name), 1),
            _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("header.roleAdmin")), 1)
          ]),
          _cache[14] || (_cache[14] = _createElementVNode("i", {
            class: "ph ph-caret-down ui-topbar-chevron",
            "aria-hidden": "true"
          }, null, -1))
        ]),
        _createElementVNode("div", _hoisted_31, [
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.user?.name), 1),
            _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.$t("header.onlineAccount")), 1)
          ]),
          _createVNode(_component_router_link, {
            to: "/profile",
            class: "dropdown-item"
          }, {
            default: _withCtx(() => [
              _cache[15] || (_cache[15] = _createElementVNode("i", {
                class: "ph ph-user-circle",
                "aria-hidden": "true"
              }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("header.myAccount")), 1)
            ]),
            _: 1,
            __: [15]
          }),
          _createVNode(_component_router_link, {
            to: "/account-settings",
            class: "dropdown-item"
          }, {
            default: _withCtx(() => [
              _cache[16] || (_cache[16] = _createElementVNode("i", {
                class: "ph ph-gear",
                "aria-hidden": "true"
              }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("header.settings")), 1)
            ]),
            _: 1,
            __: [16]
          }),
          _createElementVNode("button", {
            type: "button",
            class: "dropdown-item text-danger",
            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleLogout()))
          }, [
            _cache[17] || (_cache[17] = _createElementVNode("i", {
              class: "ph ph-sign-out",
              "aria-hidden": "true"
            }, null, -1)),
            _createTextVNode(" " + _toDisplayString(_ctx.$t("header.logout")), 1)
          ])
        ])
      ])
    ])
  ], 2))
}